import { useEffect } from "react";
import { useAuthStore } from "@/zustand/authStore";
import OpticksLink from "@/components/ui/OpticksLink/OpticksLink";
import OpticksLogo from "@/components/ui/OpticksLogos/OpticksLogo";

const AccountMissing = () => {
  const { setLogout } = useAuthStore((state) => state);

  useEffect(() => {
    setLogout();
  }, []);

  return (
    <>
      <OpticksLogo />
      <h2>Your Account is Inactive</h2>

      <p>The access to this account is currently not available.</p>
      <p>
        Please contact your Opticks representative or{" "}
        <OpticksLink
          href="mailto:support@optickssecurity.com"
          label="support@optickssecurity.com"
        />{" "}
        for more detailed information.
      </p>
    </>
  );
};

export default AccountMissing;
